export const SUCCESSFULL = 0;
export const ERROR = 1;
export const NOT_VALIDATED = 2;